<template>
  <div>

    <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center">
      <div class="bg-white w-full rounded-lg shadow">
        <div class="py-3 flex pt-5 mt-5 flex-wrap relative items-center border-gray-200 p-6 overflow-hidden">
          <div class="text-center w-full py-4 bg-whatsap text-white text-3xl mb-5 rounded"><h1 class="text-white"><img src="https://storeno.b-cdn.net/shipsen/11-2021/1638273178072.png" class="mx-2 img-whtasap" style="height: 25px;">Whatsapp Sender</h1></div>
          <!--device--->
          <div class="w-full flex items-center justify-first mb-4"><div class="w-2 h-2 bg-green-500 rounded-full mr-3"></div><span class="truncate">Devices</span><div class="h-px flex-1 border border-r border-dashed border-green-800 mx-3 "></div></div>
          <div class="w-full flex bg-device bg-gray-100 rounded p-3 flex-wrap  mx-auto mb-5">
              <div class="lg:w-1/4 md:w-1/3 w-full p-1">
                  <div class="wp_add_session cursor-pointer w-full  px-4 py-3 rounded-lg flex flex-wrap  justify-between">
                      <div class="w-5/6 flex flex-col items-center justify-center" @click="openCreateSession">
                        <span class="text-md font-semibold text-gray-900 w-full leading-5 mb-1 flex  flex-no-wrap items-center"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 24 24"><path d="M17.5 2c.276 0 .5.224.5.5v19c0 .276-.224.5-.5.5h-11c-.276 0-.5-.224-.5-.5v-19c0-.276.224-.5.5-.5h11zm2.5 0c0-1.104-.896-2-2-2h-12c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h12c1.104 0 2-.896 2-2v-20zm-9.5 1h3c.276 0 .5.224.5.501 0 .275-.224.499-.5.499h-3c-.275 0-.5-.224-.5-.499 0-.277.225-.501.5-.501zm1.5 18c-.553 0-1-.448-1-1s.447-1 1-1c.552 0 .999.448.999 1s-.447 1-.999 1zm5-3h-10v-13h10v13z"></path></svg> New device </span> 
                        <small class="text-xs font-medium text-green-900 w-full"> Connect new device </small>
                      </div> 
                      <div class="w-1/6 flex flex-col items-center justify-center">
                        <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current text-green-700 w-5"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z"></path></svg>
                      </div>
                  </div>
               </div> 
               <div v-for="(sess, index) in sessions" :key="'L'+index" class="lg:w-1/4 md:w-1/3 w-full p-1">
                  <div :class="sess.status=='CLOSED'?'border-gray-500':'border-green-600'" class="wp_item_session border w-full bg-white shadow-sm  px-4 py-3 rounded-lg flex flex-wrap justify-between">
                     <div class="w-2/3 flex flex-col">
                        <span class="text-md font-semibold text-gray-900 w-full leading-5 mb-1"> {{sess.breafName}} </span> 
                        <small v-if="sess.phone" class="font-medium text-xs text-gray-600 flex flex-no-wrap items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" class="mr-2"><path d="M17.5 2c.276 0 .5.224.5.5v19c0 .276-.224.5-.5.5h-11c-.276 0-.5-.224-.5-.5v-19c0-.276.224-.5.5-.5h11zm2.5 0c0-1.104-.896-2-2-2h-12c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h12c1.104 0 2-.896 2-2v-20zm-9.5 1h3c.276 0 .5.224.5.501 0 .275-.224.499-.5.499h-3c-.275 0-.5-.224-.5-.499 0-.277.225-.501.5-.501zm1.5 18c-.553 0-1-.448-1-1s.447-1 1-1c.552 0 .999.448.999 1s-.447 1-.999 1zm5-3h-10v-13h10v13z"></path></svg> {{sess.phone}} </small>
                        <div class="flex items-start justify-start">
                          <small :class="sess.status=='CLOSED'?'text-yellow-600 bg-yellow-200':'text-green-500 bg-green-200'" class="text-xs font-medium rounded-lg px-3">{{sess.status=='CLOSED'?"Disconnected":'Connected'}}  <i class="econ-des material-icons">brightness_1</i></small>
                        </div>
                     </div> 
                     <div v-if="!sess.active" class="w-2/6 flex items-center justify-center">
                        <div class="w-1/2 p-1 flex flex-col items-center justify-center">
                            <div @click="starSession(sess.breafName,index,sess.status)" :class="sess.status=='OPENED'?'bg-green-200 hover:bg-green-300':'bg-gray-200 hover:bg-gray-300'" class="cursor-pointer w-full py-1 flex items-center justify-center transition rounded-lg">
                              <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current w-5 text-gray-900"><path d="M8 24l3-9h-9l14-15-3 9h9l-14 15z"></path></svg>
                            </div>
                        </div> 
                        <div class="w-1/2 p-1 flex flex-col items-center justify-center">
                         <div @click="startBot(sess.breafName,index,sess.botStatus)" :class="sess.botStatus=='ACTIVE'?'bg-green-300 hover:bg-green-400':'text-gray-900 bg-gray-100'" class="w-full py-1 flex cursor-pointer items-center justify-center transition rounded-lg  opacity-50">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :class="sess.botStatus=='ACTIVE'?'text-green-800':'text-gray-900'" class="fill-current w-5"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 20l-1.359-2.038c-1.061.653-2.305 1.038-3.641 1.038-3.859 0-7-3.14-7-7h2c0 2.757 2.243 5 5 5 .927 0 1.786-.264 2.527-.708l-1.527-2.292h5.719l-1.719 6zm0-8c0-2.757-2.243-5-5-5-.927 0-1.786.264-2.527.708l1.527 2.292h-5.719l1.719-6 1.359 2.038c1.061-.653 2.305-1.038 3.641-1.038 3.859 0 7 3.14 7 7h-2z"></path></svg>
                            </div>
                        </div>
                     </div> 
                     <div v-if="sess.active" class="w-2/6 flex flex-col items-center justify-center rounded-lg"><svg viewBox="0 0 24 24" class="animate-ping h-4 w-4 bg-yellow-500 rounded-full"></svg></div>
                     <div v-if="sess.qrcode" class="w-full flex flex-col mt-4" style="min-height: 15rem;"><img alt="" :src="sess.qrcode" class="mb-2" style="width: 100%; height: 13rem; object-fit: contain;"></div>
                  </div>
               </div>
          </div>    
          <!-- /device-->
          <div class="w-full">
            
              <div class="flex flex-wrap">
                  <div class="item bg-device relative bg-white shadow-md rounded-md p-3">
                            <div class="flex items-center cursor-pointer" @click="faq_selectedF">
                              <div class="bg-indigo-100 text-indigo-400 w-8 h-8 md:w-10 md:h-10 rounded-md flex items-center justify-center font-bold text-lg font-display">
                                <span><i class="large font-bold material-icons align-bottom">{{faq_selected ? `remove` : `add`}}</i></span>
                              </div>
                              <div class="ml-3 md:ml-4 lg:ml-6 md:text-lg text-blue-600">
                                <span class="font-bold">Status settings</span>
                              </div>
                            </div>
                            <div class="max-h-0 relative overflow-hidden transition-all duration-700" v-bind:style="faq_selected ? `max-height:  715px;overflow-y: scroll` : ``">
                              <div class="text-gray-700  py-5 space-y-3">
                                <div class="w-full bg-www flex flex-wrap items-start bg-gray-100 mb-5 rounded p-3">

                                  <div class="w-full flex items-center justify-first mb-4">
                                          <div class="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                                          <span class="truncate">Warehouses</span>
                                          <div class="h-px flex-1 border border-r border-dashed border-green-800 mx-3 "></div>
                                    </div>
                                    <div  class="border mb-3 border-gray-700 hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                       
                                      <p>
                                        <v-select  label="countryName"  v-model="senders_warehouses" :options="warehouses" multiple></v-select>
                                      </p>         
                                  </div>  

                                    <div class="w-full flex items-center justify-first mb-4">
                                          <div class="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                                          <span class="truncate">Order Status</span>
                                          <div class="h-px flex-1 border border-r border-dashed border-green-800 mx-3 "></div>
                                    </div>
                                  
                                    <div v-for="(item, index) in statusOrders" :key="index" class="md:w-1/4 w-full p-2">
                                        <div class="p-3 box-w rounded bg-white shadow w-full flex flex-col relative">
                                            <label class="inline-flex items-center absolute top-0 right-0 p-2">
                                              <input type="checkbox" :disabled="item.status && ['toremind', 'unreached'].indexOf(item.status.name.toLowerCase()) == -1?true:false" v-model="item.isActive" class="form-checkbox cursor-pointer">
                                            </label> 
                                            <span class="text-center font-semibold capitalize" :style="'color:' +item.status.color"> {{item.status.name}} </span>
                                            <small class="italic text-center text-xs text-gray-600 mb-3 capitalize"> ( Order {{item.status.name}} ) </small> 
                                            <select v-model="item.session" class="form-select block w-full text-sm mb-2" style="line-height: 0.75rem !important;">
                                              <option value="" selected="selected"> -- Device -- </option> 
                                              <option v-for="(sess, index) in sessions" :key="'S'+index" :value="sess.breafName"> {{sess.breafName}} </option>
                                            </select>
                                            <button @click="editMessages(item)" class="w-full border-0 py-1 text-white bg-whatsap rounded hover:bg-whatsap-100"><svg xmlns="http://www.w3.org/2000/svg" class="inline-block text-white fill-current" width="24" height="24" viewBox="0 0 24 24"><path d="M20 9.352c0-4.852-4.75-8.352-10-8.352-5.281 0-10 3.527-10 8.352 0 1.71.615 3.39 1.705 4.695.047 1.527-.85 3.719-1.66 5.312 2.168-.391 5.252-1.258 6.648-2.115 7.698 1.877 13.307-2.842 13.307-7.892zm-13.92 2.21c-.347.275-.83.413-1.45.413-.53 0-1.001-.102-1.408-.306l.228-.902c.412.208.828.312 1.251.312.244 0 .435-.046.571-.139.262-.179.278-.539.02-.743-.125-.097-.337-.197-.641-.298-.915-.305-1.371-.781-1.371-1.43 0-.42.167-.765.503-1.036.337-.271.786-.407 1.344-.407.488 0 .913.083 1.279.249l-.248.873c-.334-.156-.684-.233-1.045-.233-.221 0-.396.043-.522.128-.25.169-.245.475-.03.655.106.089.356.205.759.347.442.156.767.35.973.581.205.231.308.518.308.861 0 .441-.175.799-.521 1.075zm5.531.334c-.076-1.901-.113-3.191-.113-3.868h-.023c-.114.509-.503 1.773-1.165 3.789h-.859c-.397-1.391-.981-3.789-.981-3.789h-.015l-.169 3.868h-1.025l.305-4.792h1.492l.845 3.306 1.024-3.306h1.509l.257 4.792h-1.082zm4.637-.314c-.348.277-.842.418-1.465.418-.506 0-.983-.089-1.439-.317l.241-.956c.4.205.811.325 1.269.325.237 0 .425-.044.555-.135.252-.169.262-.508.02-.7-.122-.095-.334-.193-.632-.294-.923-.306-1.392-.794-1.392-1.454 0-.425.174-.781.516-1.056.338-.275.796-.413 1.358-.413.49 0 .924.084 1.291.25l.02.01-.264.926c-.337-.159-.674-.246-1.061-.246-.215 0-.387.042-.509.124-.234.161-.229.444-.026.615.103.085.354.201.75.342.445.156.775.355.982.588.209.236.316.53.316.879.001.447-.178.815-.53 1.094zm6.636 7.939c-.029 1.001.558 2.435 1.088 3.479-1.419-.258-3.438-.824-4.352-1.385-3.279.798-6.064-.223-7.577-2.1.596-.086 1.178-.205 1.74-.364 1.824 1.552 3.962 1.374 6.089.855.687.422.773.507 1.665.813-.187-.816-.158-1.12-.138-1.865 1.793-2.14 1.213-4.104-.464-5.365.239-.455.439-.928.601-1.416 2.891 1.913 3.103 5.251 1.348 7.348z"/></svg> Edit Message </button>
                                        </div>
                                    </div>

                                    <div class="w-full flex items-center justify-first mt-4 mb-4">
                                          <div class="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                                          <span class="truncate">Shipping Status</span>
                                          <div class="h-px flex-1 border border-r border-dashed border-green-800 mx-3 "></div>
                                    </div>

                                    <div v-for="(item, index) in statusShippings" :key="'A'+index" class="md:w-1/4 w-full p-2">
                                        <div class="p-3 box-w rounded bg-white shadow w-full flex flex-col relative">
                                            <label class="inline-flex items-center absolute top-0 right-0 p-2">
                                              <input type="checkbox" disabled v-model="item.isActive" class="form-checkbox cursor-pointer">
                                            </label> 
                                            <span class="text-center font-semibold capitalize" :style="'color:' +item.status.color"> {{item.status.name}} </span>
                                            <small class="italic text-center text-xs text-gray-600 mb-3 capitalize"> ( Shipping {{item.status.name}} ) </small> 
                                            <select v-model="item.session" class="form-select block w-full text-sm mb-2" style="line-height: 0.75rem !important;">
                                              <option value="" selected="selected"> -- Device -- </option> 
                                              <option v-for="(sess, index) in sessions" :key="'S'+index" :value="sess.breafName"> {{sess.breafName}} </option>
                                            </select>
                                            <button @click="editMessages(item)" class="w-full border-0 py-1 text-white bg-whatsap rounded hover:bg-whatsap-100"><svg xmlns="http://www.w3.org/2000/svg" class="inline-block text-white fill-current" width="24" height="24" viewBox="0 0 24 24"><path d="M20 9.352c0-4.852-4.75-8.352-10-8.352-5.281 0-10 3.527-10 8.352 0 1.71.615 3.39 1.705 4.695.047 1.527-.85 3.719-1.66 5.312 2.168-.391 5.252-1.258 6.648-2.115 7.698 1.877 13.307-2.842 13.307-7.892zm-13.92 2.21c-.347.275-.83.413-1.45.413-.53 0-1.001-.102-1.408-.306l.228-.902c.412.208.828.312 1.251.312.244 0 .435-.046.571-.139.262-.179.278-.539.02-.743-.125-.097-.337-.197-.641-.298-.915-.305-1.371-.781-1.371-1.43 0-.42.167-.765.503-1.036.337-.271.786-.407 1.344-.407.488 0 .913.083 1.279.249l-.248.873c-.334-.156-.684-.233-1.045-.233-.221 0-.396.043-.522.128-.25.169-.245.475-.03.655.106.089.356.205.759.347.442.156.767.35.973.581.205.231.308.518.308.861 0 .441-.175.799-.521 1.075zm5.531.334c-.076-1.901-.113-3.191-.113-3.868h-.023c-.114.509-.503 1.773-1.165 3.789h-.859c-.397-1.391-.981-3.789-.981-3.789h-.015l-.169 3.868h-1.025l.305-4.792h1.492l.845 3.306 1.024-3.306h1.509l.257 4.792h-1.082zm4.637-.314c-.348.277-.842.418-1.465.418-.506 0-.983-.089-1.439-.317l.241-.956c.4.205.811.325 1.269.325.237 0 .425-.044.555-.135.252-.169.262-.508.02-.7-.122-.095-.334-.193-.632-.294-.923-.306-1.392-.794-1.392-1.454 0-.425.174-.781.516-1.056.338-.275.796-.413 1.358-.413.49 0 .924.084 1.291.25l.02.01-.264.926c-.337-.159-.674-.246-1.061-.246-.215 0-.387.042-.509.124-.234.161-.229.444-.026.615.103.085.354.201.75.342.445.156.775.355.982.588.209.236.316.53.316.879.001.447-.178.815-.53 1.094zm6.636 7.939c-.029 1.001.558 2.435 1.088 3.479-1.419-.258-3.438-.824-4.352-1.385-3.279.798-6.064-.223-7.577-2.1.596-.086 1.178-.205 1.74-.364 1.824 1.552 3.962 1.374 6.089.855.687.422.773.507 1.665.813-.187-.816-.158-1.12-.138-1.865 1.793-2.14 1.213-4.104-.464-5.365.239-.455.439-.928.601-1.416 2.891 1.913 3.103 5.251 1.348 7.348z"/></svg> Edit Message </button>
                                        </div>
                                    </div>

                                  
                                </div>
                                </div>
                               
                            </div>
                            <div v-if="faq_selected" class="w-full flex items-end justify-end mt-4 modal-footer_sender modal-footer px-5 border0-t text-right">
                                <button @click="save" class="rounded flex focus:outline-none outline-none text-gray-100 px-10 w-1/7 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"> Save</button>
                            </div>
                        </div>
                    
              </div>
          </div>
          <div class="w-full  flex items-center justify-first mt-4 mb-4"><div class="w-2 h-2 bg-green-500 rounded-full mr-3"></div><span class="truncate">Messages Histories</span><div class="h-px flex-1 border border-r border-dashed border-green-800 mx-3 "></div></div>
          <div class="w-full bg-device flex flex-wrap items-start bg-gray-100 mb-5 rounded p-3">
                <div class="flex flex-col w-full">
                  <div class="flex justify-between items-center">
                      <div class="flex flex-wrap items-center">
                          <div v-for="(item, index) in statusMessages" :key="index" class="p-1"><div @click="refreshMessages(item)" :class="item===type?'shadow-md bg-white':'bg-gray-200 hover:bg-gray-300'" class="bg-device text-gray-600 px-3 py-2 rounded text-sm cursor-pointer">{{item}} <span v-if="item===type" class="text-blue-600 text-xs "> ({{type=='ALL'?paginate.total:messages.length}}) </span></div></div>
                      </div> 
                      <div class="p-1">
                          <div @click="refreshMessages()" class="bg-device bg-white hover:bg-gray-200 text-gray-600 px-3 py-2 rounded text-sm cursor-pointer shadow"> <div class="flex flex-no-wrap items-center"><svg class="fill-current text-gray-600 mr-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.944 12.979c-.489 4.509-4.306 8.021-8.944 8.021-2.698 0-5.112-1.194-6.763-3.075l1.245-1.633c1.283 1.645 3.276 2.708 5.518 2.708 3.526 0 6.444-2.624 6.923-6.021h-2.923l4-5.25 4 5.25h-3.056zm-15.864-1.979c.487-3.387 3.4-6 6.92-6 2.237 0 4.228 1.059 5.51 2.698l1.244-1.632c-1.65-1.876-4.061-3.066-6.754-3.066-4.632 0-8.443 3.501-8.941 8h-3.059l4 5.25 4-5.25h-2.92z"/></svg> Refresh</div>  </div>
                      </div>
                  </div>    
                  <div class="overflow-x-auto">
                    <div class="p-2  align-middle inline-block min-w-full">
                          <div class="shadow bg-device overflow-hidden border-b border-gray-200 rounded relative">
                          <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                              <tr>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">From</th> 
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">To Custumer</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Country</th> 
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Status</th> 
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Created At</th> 
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Action</th> 
                              </tr>
                              </thead> 
                              <tbody class="relative bg-white divide-y divide-gray-200">
                                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                                <tr v-for="(item, index) in messages" :key="index">
                                    <td class="px-6 py-1 whitespace-nowrap"><div class="flex flex-col"><span class="font-semibold text-blue-800 text-sm"> {{item.sessionId.name.split('_')[0]}} </span> <small class="font-medium text-xs text-gray-600 flex flex-no-wrap items-center"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M17.5 2c.276 0 .5.224.5.5v19c0 .276-.224.5-.5.5h-11c-.276 0-.5-.224-.5-.5v-19c0-.276.224-.5.5-.5h11zm2.5 0c0-1.104-.896-2-2-2h-12c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h12c1.104 0 2-.896 2-2v-20zm-9.5 1h3c.276 0 .5.224.5.501 0 .275-.224.499-.5.499h-3c-.275 0-.5-.224-.5-.499 0-.277.225-.501.5-.501zm1.5 18c-.553 0-1-.448-1-1s.447-1 1-1c.552 0 .999.448.999 1s-.447 1-.999 1zm5-3h-10v-13h10v13z"/></svg> {{item.sessionId.phone}}  </small></div></td> 
                                    <td class="px-6 py-1 whitespace-nowrap "><div class="flex flex-no-wrap items-center"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" class="fill-current text-green-500"><path d="M12.068.016l-3.717 3.698 5.263 5.286h-13.614v6h13.614l-5.295 5.317 3.718 3.699 11.963-12.016z"></path></svg> <span class="font-medium text-green-800 text-sm pl-2"> {{item.to}} </span></div></td> 
                                    <td class="px-6 py-1 whitespace-nowrap"><img v-if="idWharhouse"  :src="idWharhouse.flag" class="w-4 h-4 rounded-full"></td>  
                                    <td class="px-6 py-1 whitespace-nowrap"><span class="px-3 inline-flex text-xs leading-5 font-semibold rounded-full" :class="getClass(item.status)">{{item.status}}</span></td>
                                    <td class="px-6 py-1 whitespace-nowrap text-sm text-gray-600"><span class="text-medium text-gray-600">{{$moment(item.createdAt).format('yyyy-MM-DD , h:mm')}}</span></td>
                                    <td class="px-6 py-1 whitespace-nowrap text-right text-sm font-medium"><div class="flex flex-wrap justify-left"> <div v-if="item.status=='PENDING'" @click="UpdateMessage(item._id,'CANCELED')" class="text-red-600 hover:text-red-800 cursor-pointer p-1 flex flex-no-wrap items-center"><svg xmlns="http://www.w3.org/2000/svg" class="text-red-600 fill-current mr-2" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z"/></svg>  Cancel</div></div></td>
                                </tr>
                                 <tr v-if="messages.length==0" class="intro-x">
                                    <td class="text-center padding-empty text-gray-600 py-5" colspan="6">No messages found</td>
                                  </tr>
                              </tbody>
                          </table> 
                          </div>
                    </div>
                  </div> 
                  <div class="flex justify-between items-center">
                    <div class="text-gray-600 text-xs font-medium p-1"> {{paginate.currentpage}} - {{messages.length}}  / {{paginate.total}}</div> 
                    <div v-if="paginate.lastpage > 1" class="flex flex-no-wrap">
                      <div v-if="paginate.currentpage > 1" class="p-1"><div @click="paginatation('prev')" :disabled="paginate.currentpage == 1" class="bg-white hover:bg-gray-200 text-gray-600 px-3 py-2 rounded text-sm cursor-pointer shadow flex flex-no-wrap items-center"><svg class="fill-current text-gray-600 mr-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm-4.828 11.5l4.608 3.763-.679.737-6.101-5 6.112-5 .666.753-4.604 3.747h11.826v1h-11.828z"/></svg> Previous </div></div> 
                      <div v-if="paginate.currentpage < paginate.lastpage" class="p-1"><div @click="paginatation('next')" :disabled="paginate.currentpage == paginate.lastpage" class="bg-white hover:bg-gray-200 text-gray-600 px-3 py-2 rounded text-sm cursor-pointer shadow flex flex-no-wrap items-center"><svg viewBox="0 0 24 24" class="fill-current text-gray-600 mr-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 0c-6.623 0-12 5.377-12 12s5.377 12 12 12 12-5.377 12-12-5.377-12-12-12zm0 1c-6.071 0-11 4.929-11 11s4.929 11 11 11 11-4.929 11-11-4.929-11-11-11zm4.828 11.5l-4.608 3.763.679.737 6.101-5-6.112-5-.666.753 4.604 3.747h-11.826v1h11.828z"/></svg> Next </div></div>
                    </div>
                  </div>
                  </div>
              </div>
          </div>
        </div>
    </div>  
    <!--Modal change status Shipping -->
    <vue-modal-2 name="ModalWhtasap" :headerOptions="{title: 'Messages'}" :noFooter="true" modalSize="lg" @onclose="close('ModalWhtasap')">
        <div class="bg-white rounded-lg">
            <div class="bg-white px-4 pt-0 pb-1">

                    <div class="flex flex-wrap items-start border p-5 border-dotted rounded-md border-gray-500 mb-2">
                          <div class="flex w-full flex-wrap bg-blue-100 border border-solid border-blue-200 rounded p-3 mb-3">
                                <div class="flex items-center w-full mb-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" class="fill-current text-blue-500"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"></path></svg> 
                                  <div class="w-2"></div>
                                  <span class="w-full text-md text-blue-500"> Variables </span>
                                </div> 
                                <div class="flex flex-wrap items-start w-full">
                                    <div class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [WAREHOUSE] : </b> <span class="px-1"> Warehouse country</span></div> 
                                     <div class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [CURRENCY] : </b> <span class="px-1"> Currency</span></div> 
                                    <div class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [ORDER_ID] : </b> <span class="px-1"> Order id</span></div> 
                                    <div v-if="itemToEdit.type==='shipping'" class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [ORDER_TRACKING] : </b> <span class="px-1"> Tracking Number </span></div> 
                                    <div class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [ORDER_TOTAL] : </b> <span class="px-1"> Order Total Price </span></div> 
                                    <div class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [PRODUCT_NAME] : </b> <span class="px-1"> Product name</span></div> 
                                    <div class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [PRODUCT_IMAGE] : </b> <span class="px-1"> Product image link</span></div> 
                                    <div class="flex flex-nowrap text-xs text-gray-700 w-full mb-1"><b> [CLIENT_NAME] : </b> <span class="px-1"> Client name</span></div> 
                                </div>
                                
                          </div>
                          <div class="tm_whatsapp bg-www w-full flex flex-col p-2 mb-3 rounded-lg">
                                  <div v-for="(item, index) in itemToEdit.messages" :key="'B'+index" class="relative flex items-start w-full mb-3">
                                      <div class="bg-white shadow-lg rounded-lg p-3 w-full flex flex-col h-full" style="min-height: 120px;">
                                        <small class="mb-2"> {{item.type}}  <span v-if="item.type=='image'">( .jpeg , .png , .jpg )</span></small> 
                                        <div v-if="item.type!='text'" class="w-full mb-1 rounded-md inline-flex border">
                                          <div v-if="item.type=='image'" class="ounded-md w-1/12 bg-gray-100"><img src="https://img.icons8.com/color/96/000000/image.png"/></div>
                                          <input type="text"  v-model="item.link" placeholder="link" class="form-input senders w-full">
                                        </div>
                                        <textarea placeholder="Message text" v-model="item.content"  height="100%" type="text" class="form-textarea text-sm w-full mb-0"></textarea>
                                      </div> <!----> <!----> <!----> 
                                      <div @click="removeItem(index)" class="absolute flex items-center justify-center right-0 p-1 pr-0  shadow-lg text-center text-white rounded-full bg-red-500  cursor-pointer"> <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 w-4 h-4 mr-1 w-4 h-4 mr-1"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> </div>
                                  </div>
                          </div>
                          <div class="w-2/3 p-1">
                            <label class="block text-left w-full">
                              <select v-model="typeMessage" class="form-select block w-full text-sm" style="line-height: 1.2rem !important;">
                                <option value="null" selected="selected">type </option> 
                                  <option value="text"> Text </option>
                                  <option value="link"> Link </option>
                                <option value="image"> Image </option>
                                </select>
                                </label>
                            </div>
                          <div class="w-1/3 p-1"><button @click="AddItem" type="button" class="btn_wp text-white text-sm font-semibold py-2 px-8 rounded-lg w-full">Add item</button></div>
                    </div>
                <div class="p-4 px-4 flex space-x-4 md:flex border p-5 border-dotted rounded-md border-gray-500">
                    <a href="#" @click="close('ModalWhtasap')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                    <a href="#" @click="confirmChange" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Save</a>
                </div>
            </div>    
        </div>
    </vue-modal-2>     
    <!-- end modal change status shipping -->
      <!--Modal change status Shipping -->
    <vue-modal-2 name="ModalCreateSession" :headerOptions="{title: 'New device'}" :noFooter="true" modalSize="lg" @onclose="close('ModalCreateSession')">
        <div class="bg-white rounded-lg">
            <div class="bg-white relative px-4 pt-0 pb-1">
               <loading :active.sync="session.loading" :is-full-page="fullPage"></loading>
                <div class="mt-2">
                    <div class="mb-5 w-full">
                       <label for="session_name" class="block text-gray-800 text-sm font-semibold mb-1">Device Name</label> 
                       <input required="required" id="session_name" type="text" v-model="session.session" placeholder="sample: support ..." class="wp_input border border-solid border-grey rounded-lg w-full p-3">
                    </div>
                </div>
                   
                <div class="p-4 px-4 flex space-x-4 md:flex border p-5 border-dotted rounded-md border-gray-500">
                    <a href="#" @click="close('ModalCreateSession')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                    <a href="#" @click="confirmCreateSession" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Save</a>
                </div>
            </div>    
        </div>
    </vue-modal-2>     
    <!-- end modal change status shipping -->
  </div>
</template>


<script>
const axios = require('axios');
let sio = io('https://api-wp.storeino.world');
const TOKEN = process.env.VUE_APP_ENV_TOKEN_WHATSAP_SENDER;
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      status: [],
      senders: [],
      statusOrders:[],
      statusShippings:[],
      limit: 50,
      starsession:{
        loading:false,
        session:""
      },
      sessions:[],
      session:{
        loading:false,
        session:""
      },
      type:'ALL',
      itemToEdit:{messages:[]},
      typeMessage:null,
      messages:[],
      loading:false,
      fullPage: false,
      statusMessages:["ALL","PENDING","INVALID","DELIVERED","SENT","CANCELED"],
      faq_selected:false,
      warehouses:[],
      senders_warehouses:[],
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
    };
  },
  async mounted() {
    await this.getStatus({ limit: this.limit });
    await this.getAllSession()
    // await this.AddMessage()
    await this.getMessages()
    await this.getWarehouses();
  },

  filters: {},
   computed: {
     warhouseSelected(){
       return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
    },
  },
  watch: {
      'warhouseSelected': async function(oldVal, newVal) {
            // await this.getwharhouseId();
            // await this.getMessages();
      },
      'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.getMessages();
        }
  },
  methods: {
    async getWarehouses(){
       this.warehouses=this.currentUser.warehouses;
    }, 
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
    faq_selectedF(){
       this.faq_selected=!this.faq_selected;
    },
    getClass(status){
      if(status==='PENDING') return 'bg-orange-200 text-orange-800';
      else if(status==='CANCELED' || status==='INVALID') return 'bg-red-200 text-red-800';
      else if(status==='DELIVERED' || status==='SENT') return 'bg-green-200 text-green-800';
      else return 'bg-yellow-200 text-yellow-800';
    },
    async confirmCreateSession(){
      if(!this.session.session)  {alert("Name device required", "warning");return false}
       const BASEURL = 'https://api-wp.storeino.world/v1/sessions/create';
         let axiosConfig = {
           headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "x-auth-token": TOKEN,}};
            this.session.loading=true;             
            axios.put(BASEURL,{name:this.session.session}, axiosConfig).then((res) => {  this.getAllSession(); this.session.loading=false;this.close('ModalCreateSession');     alert("Session created", "success");})
            .catch((err) => {this.session.loading=false;  console.log("error add message STOREINO error not send rrequest",err);})
    },
    async UpdateMessage(id,status){
      this.loading=true;
       const BASEURL = 'https://api-wp.storeino.world/v1/messages/update?id='+id;
         let axiosConfig = {
           headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "x-auth-token": TOKEN,
                    }};           
           await axios.put(BASEURL,{status:status} , axiosConfig).then((res) => { this.loading=false;  this.getMessages();alert("Message Upadated", "success");})
            .catch((err) => {this.loading=false;  console.log("error add message STOREINO error not send rrequest",err);})
    },
    async getAllSession() {
       try {
         const BASEURL = 'https://api-wp.storeino.world/v1/sessions/search';
         let axiosConfig = {
            headers: {'Content-Type': 'application/json;charset=UTF-8',"x-auth-token": TOKEN,},
         };
                 
           axios.get(BASEURL, axiosConfig).then((res) => { 
            this.sessions = this.reformSession(res.data.results);
            console.log("get session send request: ",this.sessions);
            })
                .catch((err) => {console.log(" get session error not send rrequest",err);})
      } catch (error) {  console.log(error); }
    },
     async refreshMessages(type=null){
       console.log('type------',type)
       const filters={page:1};
       if(type) this.type=type;
       if(this.type!='ALL') filters['status']=this.type;
       console.log('filter---------------',filters)
       await this.getMessages(filters)
     },
     async getMessages(filters={}) {
        const BASEURL = 'https://api-wp.storeino.world/v1/messages/search';
        this.loading=true;
        
        filters['info.warehouse']=this.idWharhouse._id;
         let axiosConfig = {
           headers: {
                          'Content-Type': 'application/json;charset=UTF-8',
                          "x-auth-token": TOKEN,},
                          params: filters 
                          };
                 
                 await axios.get(BASEURL, axiosConfig).then((res) => {
                    this.loading=false;
                      console.log(" Mesaages STOREINO send request: ",res.data.results);
                    if (res.data.results) {
                      this.messages = res.data.results;
                      this.paginate.total = res.data.paginate.total;
                      this.paginate.lastpage = res.data.paginate.last_page;
                      this.paginate.per_page = res.data.paginate.per_page;
                      this.paginate.currentpage = res.data.paginate.current_page;
                    } else{this.messages = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}} 
                    
                    })
                  .catch((err) => {this.loading=false;console.log("meaaseges STOREINO error not send rrequest",err);})
    },
    async AddMessage() {
        const BASEURL = 'https://api-wp.storeino.world/v1/wp/addMessage';
         let axiosConfig = {
           headers: {
                          'Content-Type': 'application/json;charset=UTF-8',
                          "x-auth-token": TOKEN,}};
           let data ={
                    "contents":[
                        {
                            "phone":"212655624982",
                            "session": "shipsen",
                            "priority": 1,
                            "messages" : [
                                {
                                    "type":"text",
                                    "content":{
                                        "text" : "Hello Moukhtar"
                                    }
                                }
                            ]
                        }
                    ]
                }      
                  axios.put(BASEURL,data, axiosConfig).then((res) => {console.log("Add message STOREINO send request: ",res);})
                  .catch((err) => {console.log("error add message STOREINO error not send rrequest",err);})
    },
    async getStatus(filters) {
        
          const resSenders = await this.$server.search("senders", filters);
         // console.log('resSenders_____',resSendersI)
          if (resSenders && resSenders.content.results){
            this.senders = resSenders.content.results; 
            if(this.senders[0].warehouses && this.senders[0].warehouses.length>0) this.senders_warehouses=this.senders[0].warehouses;
          }else this.senders = [];
          
          filters['type']=true;
          const res = await this.$server.search("status", filters);
          console.log('res status_____',res)
          if (res && res.content.results) this.status = res.content.results; 
          else this.status = [];

          this.status.forEach(arg => {
            //this.AddelementArray( arg ,this.senders);
            var index = this.senders.findIndex(x => x.status && (x.status.name.toLowerCase() === arg.name.toLowerCase()) && (x.type === arg.type)); 
            if(index === -1){
              let type="shipping";
              if(arg.name.toLowerCase() == "unreached" || arg.name.toLowerCase() == "confirmed" || arg.name.toLowerCase() == "cancelled" || arg.name.toLowerCase() == "toremind") type="order";
                this.senders.push({
                  name: arg.name.toLowerCase(),
                  type: type,
                  status: {
                      name: arg.name.toLowerCase(),
                      _id: arg._id,
                      color: arg.color,
                  },
                  isActive: false,
                  messages: [],
                });
            }
          });
          var indexx = this.senders.findIndex(x => x.type=="shipping" && x.status.name.toLowerCase() ==="cancelled"); 
          indexx === -1 ? this.senders.push({
                      name: "cancelled",
                      type: "shipping",
                      status: {
                          name: "cancelled",
                          color: "#ee2b2b",
                      },
                      isActive: false,
                      messages: [],
                    }) : console.log("object already exists")
        this.senders.sort((a, b) => a.type < b.type ? -1 : (a.type > b.type ? 1 : 0))  

        this.statusOrders = this.senders.filter(function(obj) {if (obj.type === "order") return true;else return false;});
        this.statusShippings = this.senders.filter(function(obj) {if (obj.type === "shipping") return true; else return false;});

        console.log('chunkArray------',this.statusOrders)      
    },
    async refresh() {
      this.getStatus({ limit: this.limit });
    },
    close(id){
       this.$vm2.close(id);
    },
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") page = ++this.paginate.currentpage; 
      else page = --this.paginate.currentpage;
      const filters={page:page};
      await this.getMessages(filters);
    },
    async confirmChange(){
      //Find index of specific object using findIndex method.   
      console.log("Before this.itemToEdit: ", this.senders) 
      var objIndex = this.senders.findIndex((obj => obj.status.name == this.itemToEdit.status.name && obj.type == this.itemToEdit.type));
      //Update object's name property.
      this.senders[objIndex].messages = this.itemToEdit.messages
       console.log("Before 22 this.itemToEdit: ", this.senders) 
      this.$vm2.close("ModalWhtasap");
      await this.save();
    },
    AddItem(){
      if(!this.typeMessage){
         alert("Type message is required", "warning");
         return false
      }
        this.itemToEdit.messages.push({type:this.typeMessage,content:""});
    },
    removeItem(index) {
       this.itemToEdit.messages.splice(index, 1);
    },
    openCreateSession() {
       this.$vm2.open("ModalCreateSession");
    },
    editMessages(data){
      this.itemToEdit={messages:[]}
      this.$vm2.open("ModalWhtasap");
      this.itemToEdit=data;
      if(this.itemToEdit.messages.length==0){
        this.itemToEdit.messages.push({type:"image",content:"Your Order is "+data.status.name,link:'[PRODUCT_IMAGE]'})
      }     
    },
    async save() {
      if (this.senders.length) {
       // console.log('this.senders[i]----------',this.senders)
        //return false
          for(var i=0; i < this.senders.length; i++) { 
            this.senders[i].warehouses=this.senders_warehouses;
             if(this.senders[i]._id){
                      // console.log('update lenght',this.senders[i].name)
               const data = await this.$server.update("senders", this.senders[i]);
             }else{
                const data = await this.$server.create("senders", this.senders[i]);
             }
             if(i=== this.senders.length-1)  await this.getStatus({ limit: this.limit });
          }
        alert("Whatssap sender updated", "success");
      } 
    },


  

  reformSession(list = []) {
    console.log('Connect to Sessions');
    sio.removeAllListeners();
    let data = JSON.parse(JSON.stringify(list));

    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      data[index]['breafName'] = element.name.split('_')[0];
      data[index]['qrcode'] = "";
      data[index]['active'] = false;
      
      // this.leaveSession(element.name.split('_')[0]);
      this.joinToSession(element.name.split('_')[0]);
    }
    return data;
  },
  async starSession(sessionName,index,status){
    console.log(sessionName)
    this.sessions[index]['active'] = true;
    this.joinToSession(sessionName,index);
       let BASEURL = status == "CLOSED" ? `https://api-wp.storeino.world/v1/wp/initSession` : `https://api-wp.storeino.world/v1/wp/closeSession`;
       let mess = status == "CLOSED" ? `Session started sussefely` : `Session stoped sussefely`;
         let axiosConfig = {
           headers: {
                          'Content-Type': 'application/json;charset=UTF-8',
                          "x-auth-token": TOKEN,}
                          };
                 
                  await axios.put(BASEURL,{name:sessionName}, axiosConfig).then((res) => { alert(mess, "success");this.getAllSession();console.log("int session data not send",sessionName);})
                  .catch((err) => {console.log("meaaseges STOREINO error not send rrequest",err);})
                   
  },
  async startBot(sessionName,index,status) {
       try {
        let BASEURL = status == "ACTIVE" ? `https://api-wp.storeino.world/v1/wp/stopBot` : `https://api-wp.storeino.world/v1/wp/startBot`;
        let mess = status == "ACTIVE" ? `Bot stoped sussefely` : `Bot started sussefely`;
      
         let axiosConfig = {
            headers: {'Content-Type': 'application/json;charset=UTF-8',"x-auth-token": TOKEN,},
         };
                 
         await axios.put(BASEURL,{name:sessionName}, axiosConfig).then((res) => {  alert(mess, "success"); this.getAllSession();})
            .catch((err) => {  console.log("error add message STOREINO error not send rrequest",err);})
      } catch (error) {  console.log(error); }
    },
  joinToSession(sessionName) {
    let vm = this;
    sio.emit('join', { token: TOKEN, session: sessionName });
    console.log('join ---------')
    sio.on(`updateQr_${sessionName}` , function (data) {
      for (let index = 0; index < vm.sessions.length; index++) {
          if(vm.sessions[index].breafName === data.session.split('_')[0]){
            console.log('oook equals')
               const element = vm.sessions[index];
               vm.sessions[index]['qrcode'] = data.qrcode;
          }
       }
       vm.sessions=vm.sessions;
     // vm.$set(vm.session[data.session.split('_')[0]], 'qrcode', data.qrcode);
    });
     console.log('session-------',vm.sessions);
    // sio.on(`status_${sessionName}`, function (data) {
    //   console.log(data);
    //   if (data.status == 'qrReadSuccess' || data.status == 'Connected' || data.status == 'qrReadFail') {
    //     vm.$set(vm.session, data.session.split('_')[0], null);
    //   }
    //   if (data.status == 'qrReadFail') vm.getAllSession();
    // });
  },


  async initSession(sessionName, sessionStatus) {
    this.$set(this.loading, sessionName, true);
    let brefName = sessionName.split('_')[0];
    try {
      let url = sessionStatus == "CLOSED" ? `https://api-wp.storeino.world/v1/wp/initSession` : `https://api-wp.storeino.world/v1/wp/closeSession`;
    //   await Send Request [url]
      this.$set(this.loading, sessionName, false);
      this.getAllSession();
    } catch (error) { StoreinoApp.$store.alert('error','Error starting Session'); this.$set(this.loading, sessionName, false); delete this.session[brefName]; console.log(error); }
  },
    /*********************************************************************************/
  },
};
</script>

<style>
.modal-footer_sender {
    width: 99%;
    border-top: 1px solid #3d3b3b;
    z-index: 10;
}
#vm2__cover_wrapper_ModalWhtasap .vm2_body {
    max-height: 600px;
}
#vm2_box_ModalWhtasap .vm2__close{
  display: none;
}
.econ-des{
    vertical-align: bottom;
    font-size: 15px;
}
.max-h-0 {
    max-height: 0;
}
.img-whtasap{
  display: inline-block;
  vertical-align: initial;
}
.bg-whatsap{
  background-color: #1db49b;
}
.form-input.senders{
  border-radius: 0 0.25rem 0.25rem 0;
}
.bg-whatsap-100{
  background-color: #197667;
}
.box-w{
  border: 2px solid #77d7c8;
}
.btn_wp {
    transition: 300ms;
    background: #10b981;
    color: #fff;
    border: none;
    cursor: pointer;
}
.wp_add_session {
    transition: 300ms;
    border: 1px dashed #10b981;
    background: #E7F0E4;
}
.wp_item_session,.wp_add_session {
     min-height: 86px;
}
.bg-www{
    border: 2px solid #77d7c8;
    background-color: #E7F0E4;
}
.bg-device{
   border: 2px solid #77d7c8;
}
.tm_whatsapp {
    background-image: url(https://static.whatsapp.net/rsrc.php/v1/yQ/r/dPFl9fRFF9u.jpg);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: auto 265px;
    min-height: 250px;
    max-height: 250px;
    overflow-x: auto;
}
</style>




